import type { LazyQueryHookOptions, QueryHookOptions } from "@apollo/client";
import { useLazyQuery, useQuery, gql } from "@apollo/client";

import type { WholesaleCart } from "@shared/data/splinters/WholesaleCart.fragment";
import { WHOLESALE_CART } from "@shared/data/splinters/WholesaleCart.fragment";

const WholesaleCart_Shared_Query = gql`
  query WholesaleCart_Shared_Query {
    currentOffice {
      id
      wholesaleCart(updatePromotions: true) {
        ...WholesaleCart
      }
    }
  }
  ${WHOLESALE_CART}
`;

interface WholesaleCartQueryData {
  currentOffice: {
    id: string;
    wholesaleCart: WholesaleCart;
  };
}

const useWholesaleCartQuery = (options?: QueryHookOptions<WholesaleCartQueryData>) =>
  useQuery<WholesaleCartQueryData>(WholesaleCart_Shared_Query, options);

const useWholesaleCartLazyQuery = (options?: LazyQueryHookOptions<WholesaleCartQueryData>) =>
  useLazyQuery<WholesaleCartQueryData>(WholesaleCart_Shared_Query, options);

export type { WholesaleCartQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useWholesaleCartQuery, useWholesaleCartLazyQuery, WholesaleCart_Shared_Query };
